import { render, staticRenderFns } from "./AppApiEditModal.vue?vue&type=template&id=1faf9154&scoped=true"
import script from "./AppApiEditModal.vue?vue&type=script&lang=js"
export * from "./AppApiEditModal.vue?vue&type=script&lang=js"
import style0 from "./AppApiEditModal.vue?vue&type=style&index=0&id=1faf9154&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faf9154",
  null
  
)

export default component.exports